interface AclType {
    [name: string]: (string | '*')[];
}

export const ACL: AclType = {
    'AdminManagement': ['Administrator'],
    'ManagerManagement': ['Administrator', 'Manager'],
};